import { useEffect } from 'react';
import type { CombinedError } from 'urql';
import { useNoticeBannersStackContext } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';
import { getUrqlError } from '@order/utils';

import { useChallengesTelemetry } from '../../../../ChallengesScreen.telemetry';

export const useChallengeOptInErrorHandler = (error?: CombinedError) => {
  const { handleChallengesFailedTelemetry } = useChallengesTelemetry();
  const { push: addNoticeBanner } = useNoticeBannersStackContext();
  const { t } = useLocalizationContext();

  useEffect(() => {
    if (!error) return;

    const userError = t('challenges.rewards.error.start-server-error');
    const systemError = getUrqlError(error);

    handleChallengesFailedTelemetry(userError, systemError);
    addNoticeBanner({
      text: userError,
      palette: 'caution',
    });
  }, [addNoticeBanner, handleChallengesFailedTelemetry, error, t]);
};
